import { HttpErrorResponse } from '@angular/common/http';

import {
  createEntityCollectionStore,
  getEntityCollectionActions,
  ngrxEvent,
} from '@recruitee/ngrx';
import type {
  ApplicationsParams,
  ClaimStatus,
  ReferralApplication,
} from '@recruitee/referrals-types';

import { EntityStoreKey } from './types';

const idSelector = ({ id }: { id: number }) => id;
const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<ReferralApplication>()(EntityStoreKey.applications, {
    customActions: adapter => {
      const actions = getEntityCollectionActions(adapter, idSelector);

      return {
        fetchPaginatedCollection: (state, payload: { params: ApplicationsParams }) =>
          adapter.markAsPending(state),
        settleApplication: (state, payload: { id: number; data: ClaimStatus }) =>
          actions.updateOnePessimistic(state, { data: { id: payload.id } }),
        settleApplicationSuccess: actions.updateOnePessimisticSuccess,
        settleApplicationFailed: actions.updateOnePessimisticFailed,
        bulkSettleApplication: ngrxEvent<{ applicationIds: number[]; data: ClaimStatus }>(),
        bulkSettleApplicationSuccess: ngrxEvent<{ uuid: string }>(),
        bulkSettleApplicationFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
      };
    },
  });

export {
  actions as ReferralsApplicationsActions,
  reducer as ReferralsApplicationsReducer,
  selectors as ReferralsApplicationsSelectors,
  namespace as ReferralsApplicationsNamespace,
};
